export const SET_IMAGE = "Set Image";
